import Coach from '@/views/program/Index'
import CoachList from '@/views/program/List'
import CoachEdit from '@/views/program/Edit'

export default {
  name: '节目管理',
  path: 'program',
  component: Coach,
  redirect: 'program/list',
  children: [{
    name: '节目列表',
    path: 'list',
    component: CoachList,
    meta: {
      button: {
        text: ' + 节目',
        path: 'add'
      }
    }
  },
  {
    name: '添加节目',
    path: 'add',
    component: CoachEdit,
    meta: {
      activePath: '/main/program/list'
    }
  },
  {
    name: '编辑节目',
    path: 'edit',
    component: CoachEdit,
    meta: {
      activePath: '/main/program/list'
    }
  },
  {
    name: '节目详情',
    path: 'view/:id',
    component: require('@/views/program/view'),
    redirect: 'view/:id/course',
    children: [
      {
        name: '节目课程',
        path: 'course',
        component: require('@/views/program/view/course'),
        meta: {
          activePath: '/main/program/list'
        }
      },
      {
        name: '节目会员',
        path: 'member',
        component: require('@/views/program/view/member'),
        meta: {
          activePath: '/main/program/list'
        }
      }
    ]
  }
  ]
}



// WEBPACK FOOTER //
// ./src/router/program/index.js